import React from "react";
import { Link } from "react-router-dom";
import "./Garagecleanoutsheader.css";

export default function Garagecleanoutsheader() {
  const base = process.env.PUBLIC_URL;

  return (
    <section
      className="gc-hero"
      role="banner"
      aria-label="Garage Cleanouts hero banner"
    >
      {/* Background image (full width) */}
      <img
        className="gc-hero__bg"
        src={`${base}/(232).webp`}
        alt="Professional garage cleanout team at work"
        loading="eager"
      />

      {/* Contrast overlay */}
      <div className="gc-hero__overlay" aria-hidden="true" />

      {/* Centered content */}
      <div className="gc-hero__content">
        <nav className="gc-hero__breadcrumb" aria-label="Breadcrumb">
          <Link to="/" className="gc-hero__breadcrumb-link">Home</Link>
          <span className="gc-hero__breadcrumb-sep" aria-hidden="true">›</span>
          <span className="gc-hero__breadcrumb-current">Garage Cleanouts</span>
        </nav>

        <h1 className="gc-hero__title">Garage Cleanouts</h1>
        <p className="gc-hero__subtitle">
          Professional garage clearing services to reclaim your space.
        </p>
      </div>

      {/* Premium depth touches */}
      <div className="gc-hero__vignette" aria-hidden="true" />
      <div className="gc-hero__grain" aria-hidden="true" />
    </section>
  );
}
